var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-instant-search',{attrs:{"search-client":_vm.searchClient,"index-name":_vm.searchIndex}},[_c('ais-search-box',{attrs:{"class-names":{
      'ais-SearchBox': 'searchbox',
    }}},[_c('debounced-search-box',{attrs:{"search-index-suggestions":_vm.searchIndex + '_query_suggestions',"delay":250,"search-base-url":_vm.searchBaseUrl,"placeholder":_vm.placeholder,"event":_vm.event}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }